import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function Sejarah({ data }) {
  return (
    <>
      <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
        <section className="flex md:justify-end md:space-x-3 items-start md:mt-20">
          <div className="w-1/2 -sm:container flex flex-col pt-10">
            <div className="flex justify-end md:space-x-4 -md:space-x-2 items-center">
              <div className="bg-purple md:w-64 md:h-4 -md:h-1 -md:w-11"></div>
              <h1 className="text-6xl -md:text-lg text-yellow italic font-black text-right">
                {data.title}
              </h1>
            </div>
            <h2 className="-md:text-sm md:text-4xl italic font-medium text-purple text-right">
              {data.subtitle}
            </h2>
            <p
              className="md:ml-auto md:text-2xl -md:text-xs font-medium text-right md:mt-12"
              dangerouslySetInnerHTML={{
                __html: `${data.items[0].description}`,
              }}
            />
          </div>
          <img
            className="md:w-1/3 -md:w-5/12 -md:ml-auto -md:mt-10"
            src={data.items[0].image}
            alt="Rektor"
          />
        </section>
      </ScrollAnimation>

      <div className="md:space-y-28">
        {data.items.map((item, i) => {
          if (i !== 0) {
            return (
              <ScrollAnimation
                animateOnce={true}
                key={i}
                animateIn={`${
                  (i + 1) % 2 === 0 ? "fadeInLeft" : "fadeInRight"
                }`}
              >
                <section
                  className={`flex md:space-x-8 items-center ${
                    (i + 1) % 2 === 0 ? "justify-start" : "justify-end"
                  }`}
                >
                  {(i + 1) % 2 === 0 ? (
                    <img
                      className="md:w-1/3 -md:w-5/12 mr-auto"
                      src={item.image}
                      alt="Rektor"
                    />
                  ) : (
                    <div className="w-1/2 -md:container flex flex-col">
                      <p
                        className="md:text-2xl -md:text-xs w-10/12 font-medium mt-12"
                        dangerouslySetInnerHTML={{
                          __html: `${item.description}`,
                        }}
                      />
                      {item.prodi && (
                        <ul className="md:text-2xl -md:text-xs list-inside -md:list-outside -md:pl-6 list-disc">
                          {item.prodi.map((prodi, i) => (
                            <li key={i}>{prodi}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                  {(i + 1) % 2 === 0 ? (
                    <div className="w-1/2 -md:container flex flex-col">
                      <p
                        className="text-2xl -md:text-xs font-medium mt-12"
                        dangerouslySetInnerHTML={{
                          __html: `${item.description}`,
                        }}
                      />
                    </div>
                  ) : (
                    <img
                      className="md:w-1/3 -md:w-5/12 -md:ml-auto"
                      src={item.image}
                      alt="Rektor"
                    />
                  )}
                </section>
              </ScrollAnimation>
            );
          } else {
            return null;
          }
        })}
      </div>
    </>
  );
}
